import React from 'react';
import { Card, CardContent } from './ui/card';
import { Check, Dna, Archive, Scale, Users, Shield, Map, Leaf, Utensils } from 'lucide-react';
import { features } from '../mock/data';

const iconComponents = {
  dna: Dna,
  archive: Archive,
  scale: Scale,
  users: Users,
  shield: Shield,
  map: Map,
  leaf: Leaf,
  utensils: Utensils
};

const Features = () => {
  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            Reclaim Your Ancestral Legacy
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            TribalRoot.Ai blends ancestral science with modern artificial intelligence to create a complete ecosystem for genealogy, governance, wellness, and cultural restoration.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {features.map((feature, index) => {
            const IconComponent = iconComponents[feature.icon] || Dna;
            
            return (
              <Card 
                key={index} 
                className="bg-white border border-gray-200 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group"
              >
                <CardContent className="p-6">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-green-200 transition-colors">
                    <IconComponent className="w-8 h-8 text-green-700" />
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {feature.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {feature.description}
                  </p>

                  {/* Feature Details */}
                  <ul className="space-y-2">
                    {feature.details.map((detail, detailIndex) => (
                      <li key={detailIndex} className="flex items-start text-sm text-gray-700">
                        <Check className="w-4 h-4 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                        <span>{detail}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;